import React, { FC } from 'react'
import { Text, Flex } from '@ads/front-ds'
import { TTranslationsKeys, lng } from '@ads/front-core/locales'

export interface ICampaignSectionHeader {
  headerLngKey: TTranslationsKeys
  headerLngArgs?: Record<string, unknown>
  descriptionLngKey?: TTranslationsKeys
  descriptionLngArgs?: Record<string, unknown>
}

export const CampaignSectionHeader: FC<ICampaignSectionHeader> = ({
  headerLngKey,
  headerLngArgs,
  descriptionLngKey,
  descriptionLngArgs,
}) => (
  <Flex flexDirection="column" gap="xxs">
    <Text fontSize="l">{lng(headerLngKey, headerLngArgs)}</Text>
    {descriptionLngKey && (
      <Text
        fontSize="m"
        color="grey50"
        styleCss={{ whiteSpace: 'break-spaces' }}
      >
        {lng(descriptionLngKey, descriptionLngArgs)}
      </Text>
    )}
  </Flex>
)
